'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EnterpriseIconHotel = exports.EnterpriseIconCar = exports.EnterpriseIconCopy = exports.EnterpriseIconTrash = exports.EnterpriseIconConfig = undefined;

var _Config = require('./Config');

var _Config2 = _interopRequireDefault(_Config);

var _Copy = require('./Copy');

var _Copy2 = _interopRequireDefault(_Copy);

var _Trash = require('./Trash');

var _Trash2 = _interopRequireDefault(_Trash);

var _Car = require('./Car');

var _Car2 = _interopRequireDefault(_Car);

var _Hotel = require('./Hotel');

var _Hotel2 = _interopRequireDefault(_Hotel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.EnterpriseIconConfig = _Config2.default;
exports.EnterpriseIconTrash = _Trash2.default;
exports.EnterpriseIconCopy = _Copy2.default;
exports.EnterpriseIconCar = _Car2.default;
exports.EnterpriseIconHotel = _Hotel2.default;
exports.default = {
    Config: _Config2.default,
    Trash: _Trash2.default,
    Copy: _Copy2.default,
    Car: _Car2.default,
    Hotel: _Hotel2.default
};


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseIcons/index.js
// module id = 1596
// module chunks = 0